import { ComboChartMarketHistoryRentalPrices, ComboChartMarketHistorySellPrices, Text } from '../../';
import TitleEvaluation from './TitleEvaluation';
import { translateText } from '../../../../helpers/util';
import { useApp } from '../../../../contexts';

export const ChartCapRate = ({officeId, period=12, reloadTrigger, comparativeUniverse}) => {
    const { language, translations, userCountry } = useApp();


    return (
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, position: 'relative' }}>
            <TitleEvaluation title={translateText("Evolução do Mercado", language, translations, userCountry)} backgroundColor='#F3F3F3' colorTitle="#555555" />
            <Text style={{ ...styles.titleChart, backgroundColor: '#10587f', color: '#FFF', padding: 3, borderRadius: 8, paddingLeft: 10, paddingRight: 10 }}>{translateText("Locação", language, translations, userCountry)}</Text>
            <div style={{ ...styles.divChart }}>
                <ComboChartMarketHistoryRentalPrices comparativeUniverse={comparativeUniverse} title={translateText("Locação", language, translations, userCountry)} officeId={officeId} period={period} reloadTrigger={reloadTrigger} />
            </div>
            <Text style={{ ...styles.titleChart, backgroundColor: '#568C62', color: '#FFF', padding: 3, borderRadius: 8, paddingLeft: 10, paddingRight: 10 }}>{translateText("Venda", language, translations, userCountry)}</Text>
            <div style={{ ...styles.divChart }}>
                <ComboChartMarketHistorySellPrices comparativeUniverse={comparativeUniverse} title={translateText("Venda", language, translations, userCountry)} officeId={officeId} period={period} reloadTrigger={reloadTrigger}/>
            </div>
        </div>
    );
}

const styles = {
    titleChart:{
        fontSize: 16,
        marginBottom: 5,
        width: 'fit-content',
    },
    divChart: {
        // backgroundColor: "#F3F3F3",
        height: 280,
        marginBottom: 15,
        borderRadius: 15
    }
}